// export const day1StartTime = new Date('2021-01-20T08:00:00-0600');
// export const siteLaunchStartTime = new Date('2021-02-22T08:00:00-0800');
export const siteLaunchStartTime = new Date(1614009600000); // this date is the one above
